import { useEffect, useRef, useState } from 'react';

const KONAMI_CODE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a'
];

export const useKonamiCode = () => {
  const [konamiActivated, setKonamiActivated] = useState(false);
  const [coffeeRainActive, setCoffeeRainActive] = useState(false);
  const [snowThemeActive, setSnowThemeActive] = useState(false);
  const keysPressed = useRef([]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      keysPressed.current.push(e.key);
      
      // Keep only the last 10 keys
      if (keysPressed.current.length > 10) {
        keysPressed.current.shift();
      }

      // Check if the sequence matches
      const sequence = keysPressed.current.join(',');
      const expectedSequence = KONAMI_CODE.join(',');

      if (sequence === expectedSequence) {
        triggerKonamiEffects();
        keysPressed.current = []; // Reset after activation
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const triggerKonamiEffects = () => {
    console.log('🎮 KONAMI CODE ACTIVATED! 🎮');
    setKonamiActivated(true);

    // Effect 1: Coffee Rain (3 seconds)
    setCoffeeRainActive(true);
    setTimeout(() => setCoffeeRainActive(false), 3000);

    // Effect 2: Snow Theme (permanent until page reload)
    setSnowThemeActive(true);

    // Reset main activation flag after 3 seconds
    setTimeout(() => setKonamiActivated(false), 3000);
  };

  return {
    konamiActivated,
    coffeeRainActive,
    snowThemeActive
  };
};

export default useKonamiCode;
